import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Row,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form,
    Label
} from "reactstrap";
import { API_ENDPOINTS } from "api/endpoints";
import FormInput from "components/FormInput";
import ReactSelect from "components/ReactSelect";
import CreateApplication from 'components/Button/createApplicationBtn'
import BackBtn from "components/Button/backBtn";
import { LogoUpload } from "components/Uploadfile/LogoUpload";
import trash from 'assets/images/bxs-trash.svg';
import { useDispatch } from "react-redux";
import classnames from "classnames"
import _ from 'lodash';
import { history } from "helpers/utils";
import { Toast } from "helpers/Toast";
import { MdEdit } from "react-icons/md";
import { CONTENT_RATING_DROPDOWN } from "helpers/variables";
import validate from "helpers/validation";
import { addNewCombo } from "store/combo/actions";
import moment from "moment";
import Select from 'react-select'

const ComboDetail = (props) => {
    const { match: { params } } = props

    const [isLoading, setLoading] = useState(false)
    const [isBtnLoading, setBtnLoading] = useState(false)
    const [isEdit, setEdit] = useState(false)
    const [comboDetail, setDetail] = useState({
        ComboCode: null,
        deal_code: null,
        Validity: null,
        Status: false,
        isPublished: false,
        StartDate: null,
        expiry_date: null,
        createdBy: '',
        available_Discount: null,
    })
    const [errors, setErrors] = useState({
        ComboCode: null,
        deal_code: null,
        Validity: null,
        StartDate: null,
        expiry_date: null,
        createdBy: '',
        available_Discount: null,
    })

    useEffect(() => {
        getApis()
    }, []);

    const getApis = async () => {
        setLoading(true)
        if (params && params.id && !isEdit) {
            await getOneCombo(params.id)
        }
        setLoading(false)
    }


    const getOneCombo = async (id) => {
        try {
            const res = await API_ENDPOINTS.getComboDetail(id)
            if (res && !_.isEmpty(res)) {
                setEdit(true)
                setDetail({
                    ...res,
                    Status: res?.Status === 'Active' ? true : false,
                    isPublished: res?.isPublished,
                    StartDate: res.StartDate != null ? moment(res.StartDate).format('YYYY-MM-DD') : null,
                    expiry_date: res.expiry_date != null ? moment(res.expiry_date).format('YYYY-MM-DD') : null,
                })

            }
        } catch (error) {
        }
    }

    const onChange = (name, value) => {
        setDetail({ ...comboDetail, [name]: value })
        setErrors({ ...errors, [name]: undefined })
    }

    const saveComboDetail = async () => {
        let validation = {
            ...inputValidations
        }
        const notValid = validate(comboDetail, validation);
        if (notValid) {
            setErrors(notValid)
        } else {
            setBtnLoading(true)
            let payload = {
                ...comboDetail,
                StartDate: comboDetail.StartDate != null ? moment(comboDetail.StartDate).format('YYYY-MM-DD') : null,
                expiry_date: comboDetail.expiry_date != null ? moment(comboDetail.expiry_date).format('YYYY-MM-DD') : null,
                Status: comboDetail.Status ? 'Active' : 'InActive',
            }
            if (isEdit) {
                payload["_id"] = comboDetail._id
            }
            let res = await API_ENDPOINTS.createOrEditCombo({ body: payload })
            setDetail({
                ...comboDetail,
                ...res,
                StartDate: comboDetail.StartDate,
                expiry_date: comboDetail.expiry_date
            })
            setBtnLoading(false)
        }
    }

    const deleteCombo = async () => {
        let payload = {
            body: {
                ...comboDetail,
                isDeleted: true,
                isPublished: false
            }
        }
        let res = await API_ENDPOINTS.createOrEditCombo(payload)
        history.goBack()
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {isLoading ? (
                        <div>...Data Loading.....</div>
                    ) :
                        <>
                            <Row>
                                <Col xs="12">
                                    <div className="page-title-box d-flex">
                                        <BackBtn history={props.history} />
                                        <h4 className="mb-0 font-size-18 px-2">{isEdit ? "Edit Combo" : 'Add new Combo'}</h4>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <div className="content clearfix mt-4">
                                                <FormInput
                                                    placeholder="Enter Combo Code"
                                                    name="ComboCode"
                                                    type='text'
                                                    formGroupClassName="row"
                                                    label='Combo Code'
                                                    maxLength={70}
                                                    labelClassName="col-md-2 col-form-label"
                                                    value={comboDetail['ComboCode']}
                                                    error={errors?.ComboCode}
                                                    onChange={(...params) => onChange(...params)}
                                                />
                                                <FormInput
                                                    placeholder="Enter Deal Code"
                                                    name="deal_code"
                                                    type='text'
                                                    formGroupClassName="row"
                                                    label='Deal Code'
                                                    maxLength={70}
                                                    labelClassName="col-md-2 col-form-label"
                                                    value={comboDetail['deal_code']}
                                                    error={errors?.deal_code}
                                                    onChange={(...params) => onChange(...params)}
                                                />
                                                <FormInput
                                                    name1="StartDate"
                                                    name2="expiry_date"
                                                    type='flat-datepicker'
                                                    formGroupClassName="row"
                                                    label='Deal Date'
                                                    labelClassName="col-md-2 col-form-label"
                                                    value1={comboDetail['StartDate']}
                                                    value2={comboDetail['expiry_date']}
                                                    onChangeDate1={(...params) => onChange(...params)}
                                                    onChangeDate2={(...params) => onChange(...params)}
                                                />
                                                <FormInput
                                                    placeholder="Validity"
                                                    name="Validity"
                                                    type='number'
                                                    formGroupClassName="row"
                                                    label='Validity'
                                                    maxLength={160}
                                                    labelClassName="col-md-2 col-form-label"
                                                    value={comboDetail['Validity']}
                                                    error={errors?.Validity}
                                                    onChange={(...params) => onChange(...params)}
                                                />
                                                <FormInput
                                                    placeholder="Discount"
                                                    name="available_Discount"
                                                    type='number'
                                                    formGroupClassName="row"
                                                    label='Discount'
                                                    maxLength={160}
                                                    labelClassName="col-md-2 col-form-label"
                                                    value={comboDetail['available_Discount']}
                                                    error={errors?.available_Discount}
                                                    onChange={(...params) => onChange(...params)}
                                                />
                                                <FormInput
                                                    name="Status"
                                                    formGroupClassName="row"
                                                    label='Status'
                                                    type={"two-way-switch"}
                                                    leftLabel="Inactive"
                                                    rightLabel="Active"
                                                    labelClassName="col-md-2 col-form-label"
                                                    value={comboDetail['Status']}
                                                    onChange={(...params) => onChange(...params)}
                                                />
                                                <FormInput
                                                    name="isPublished"
                                                    formGroupClassName="row"
                                                    label='Publish'
                                                    type={"two-way-switch"}
                                                    leftLabel="No"
                                                    rightLabel="Yes"
                                                    labelClassName="col-md-2 col-form-label"
                                                    value={comboDetail['isPublished']}
                                                    onChange={(...params) => onChange(...params)}
                                                />
                                                <div className="d-flex justify-flex-end">
                                                    {!isBtnLoading ?
                                                        <button
                                                            type="submit"
                                                            className="primary_btn create_button"
                                                            onClick={() => saveComboDetail()}
                                                        >
                                                            Save
                                                        </button>
                                                        :
                                                        <button
                                                            type="submit"
                                                            className="primary_btn create_button"
                                                            onClick={() => null}
                                                        >
                                                            Loading
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            {isEdit &&
                                <Row>
                                    <Col lg={12}>
                                        <Row>
                                            <Col lg={3}>
                                                <div>
                                                    <p
                                                        className="danger"
                                                        onClick={() => deleteCombo()}
                                                    >Delete Combo</p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            }
                        </>}
                </Container>
            </div>
        </React.Fragment >
    )
}

export { ComboDetail }

let inputValidations = {
    ComboCode: {
        presence: {
            allowEmpty: false,
            message: "^Combo Code can't be blank"
        }
    },
    deal_code: {
        presence: {
            allowEmpty: false,
            message: "^Deal Code can't be blank"
        }
    },
    Validity: {
        presence: {
            allowEmpty: false,
            message: "^Validity can't be blank"
        }
    },
    StartDate: {
        presence: {
            allowEmpty: false,
            message: "^Start Date can't be blank"
        }
    },
    available_Discount: {
        presence: {
            allowEmpty: false,
            message: "^Discount can't be blank"
        }
    }
}